import { GlLoadingIcon } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import CeCompactCodeDropdown from '../../../../../../../app/assets/javascripts/repository/components/code_dropdown/compact_code_dropdown.vue?vue3';
import WorkspacesDropdownGroup from '../../../workspaces/dropdown_group/components/workspaces_dropdown_group.vue?vue3';
import GetProjectDetailsQuery from '../../../workspaces/common/components/get_project_details_query.vue?vue3';
import glLicensedFeaturesMixin from '~/vue_shared/mixins/gl_licensed_features_mixin';
export default {
    name: 'CompactCodeDropdown',
    components: {
        GetProjectDetailsQuery,
        WorkspacesDropdownGroup,
        CeCompactCodeDropdown,
        GlLoadingIcon
    },
    mixins: [
        glLicensedFeaturesMixin()
    ],
    inject: [
        'newWorkspacePath'
    ],
    props: {
        ...CeCompactCodeDropdown.props,
        projectPath: {
            type: String,
            required: true
        },
        projectId: {
            type: String,
            required: true
        },
        gitRef: {
            type: String,
            required: false,
            default: ''
        }
    },
    data () {
        return {
            projectDetailsLoaded: false,
            supportsWorkspaces: false
        };
    },
    computed: {
        isWorkspacesDropdownGroupAvailable () {
            return this.glLicensedFeatures.remoteDevelopment;
        },
        projectIdAsInt () {
            return parseInt(this.projectId, 10);
        }
    },
    methods: {
        onProjectDetailsResult ({ clusterAgents }) {
            this.projectDetailsLoaded = true;
            this.supportsWorkspaces = clusterAgents.length > 0;
        },
        onProjectDetailsError () {
            this.projectDetailsLoaded = true;
        }
    }
};
